export const URL_LINKDIN = 'https://www.linkedin.com/in/willharveytech';
export const URL_EMAIL = 'mailto:willharvey.techsolutions@gmail.com';
export const URL_GITHUB = 'https://github.com/Bill1083';